.card--with-illustration {
    grid-column: span 2;
    grid-row: span 2;
}

.card--with-illustration-right {
    grid-column: 2 / span 2;
    grid-row: span 2;
}

.grid-right-illustration {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-flow: dense;
    gap: 16px;
}
